module.exports = __webpack_public_path__ + "../static/img/other-alert.c2800b2e.png";